<template>
  <div class="mdm-table">
    <h3 class="title-page">{{ $t("productCreate") }}</h3>
    <div class="admin_container">
      <div class="text-right" v-if="productsInBasket.length">
        <VChip
          @click="$refs.createOrderBasketRef.show()"
          class="ma-2"
          color="primary"
          text-color="white"
        >
          {{ productsInBasket.length }}
          <v-icon right> mdi-basket</v-icon>
        </VChip>
      </div>
      <div class="mobile_simple overflow-auto d-flex">
        <div class="flex-grow-1">
          <TableWithAttribute :headers="headers" :items="products">
            <template #filter.name>
              <custom-input-text
                clearable
                @input="searchHandler"
                class="user_input no-margin"
                v-model="productFilter.name"
              ></custom-input-text>
            </template>
            <template #filter.attrs>
              <custom-input-text
                clearable
                @input="searchHandler"
                class="user_input no-margin"
                v-model="productFilter.attribute"
              ></custom-input-text>
            </template>
            <template v-if="$i18n.locale === 'uz'" #item.attrs="{ item }">
              {{ item.attrs_uz.join(" || ") }}
            </template>
            <template v-else-if="$i18n.locale === 'en'" #item.attrs="{ item }">
              {{ item.attrs_en.join(" || ") }}
            </template>
            <template v-else #item.attrs="{ item }">
              {{ item.attrs_ru.join(" || ") }}
            </template>
            <template #filter.group_name>
              <CustomSelect
                clearable
                @input="searchHandler"
                v-model="productFilter.groupId"
                class="user_input no-margin"
                :items="productGroups"
              ></CustomSelect>
            </template>

            <template #item.action="{ item }">
              <VMenu
                v-model="item.openedMenu"
                :ref="`menu-${item.id}`"
                :close-on-content-click="false"
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <VBtn color="primary" dark v-bind="attrs" v-on="on">
                    {{ $t("addToBasket") }}
                  </VBtn>
                </template>
                <VCard>
                  <VCardText>
                    <ValidationObserver v-slot="{ handleSubmit }">
                      <CustomInputText
                        name="count"
                        v-model="item.orderCount"
                        rules="required"
                        :placeholder="$t('count')"
                        class="user_input"
                        type="number"
                      ></CustomInputText>
                      <CustomSelect
                        v-model="item.selectedUnitType"
                        rules="required"
                        name="unit_type"
                        :item-text="`name_${$i18n.locale}`"
                        class="user_input"
                        :items="item.unitTypes"
                      ></CustomSelect>
                      <VBtn
                        @click="handleSubmit(() => addProductToBasket(item))"
                        class="mt-2"
                        width="100%"
                        color="primary"
                        >{{ $t("add") }}
                      </VBtn>
                    </ValidationObserver>
                  </VCardText>
                </VCard>
              </VMenu>
            </template>
          </TableWithAttribute>
          <VuePagination
            @update:limit="
              (limit) => {
                productParams.limit = limit;
                productParams.page = 1;
                changePage();
              }
            "
            v-model="productParams.page"
            :length="lastPage"
            @input="changePage"
            max-page
            :limit="productParams.limit"
          />
        </div>
        <CreateOrderBasket
          @orderCreated="onCreatedOrder"
          ref="createOrderBasketRef"
          :products="productsInBasket"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TableWithAttribute from "@/components/ui/table-with-attribute/TableWithAttribute";
import VuePagination from "@/components/ui/vue-pagination/VuePagination";
import { debounce, makerPagination } from "@/utils/pureFunctions";
import CreateOrderBasket from "@/components/division/CreateOrderBasket";

export default {
  data() {
    return {
      productsInBasket: [],
      productGroups: [],
      lastPage: 0,
      productParams: {
        yesProduct: true,
        limit: 15,
        page: 1,
      },
      productFilter: {
        groupId: null,
      },
      products: [],
    };
  },
  components: { CreateOrderBasket, VuePagination, TableWithAttribute },
  methods: {
    onCreatedOrder() {
      this.productsInBasket = [];
    },
    addProductToBasket(item) {
      item.unitType = item.unitTypes.find(
        (u) => item.selectedUnitType === u.id
      );
      item.openedMenu = false;
      this.productsInBasket.push({ ...item });
      localStorage.setItem(
        "products_in_basket",
        JSON.stringify(this.productsInBasket)
      );
    },
    async getProducts() {
      this.showLoading();
      const params = {
        ...this.productParams,
        ...this.productFilter,
        page: this.productParams.page - 1,
      };
      try {
        const {
          data: { total, data },
        } = await this.$http.get("product/list", {
          params,
        });
        this.lastPage = makerPagination({
          total,
          limit: params.limit,
        }).lastPage;
        this.products = data.map((item) => {
          return {
            unitType: null,
            openedMenu: false,
            ...item,
            orderCount: null,
            selectedUnitType:
              item.unitTypes?.length === 1 ? item.unitTypes[0].id : null,
          };
        });
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    async changePage() {
      const { page } = this.productParams;
      await this.$router.replace({ query: { page: `${page}` } });
      this.showLoading();
      await this.getProducts();
      this.clearLoading();
    },
    searchHandler: debounce(async function () {
      if (this.productParams.page !== 1) {
        this.productParams.page = 1;
        await this.$router.replace({ query: { page: "1" } });
      }
      await this.getProducts();
    }, 300),
  },
  computed: {
    headers() {
      return [
        { text: this.$t("action"), value: "action" },
        {
          text: this.$t("name"),
          value: "name",
        },
        {
          text: this.$t("count"),
          value: "remains",
        },
        //        {
        //          text: this.$t("accountCode"),
        //          value: "accountingCode",
        //        },
        {
          text: this.$t("group"),
          value: "group_name",
        },
        {
          text: this.$t("category"),
          value: "type_name",
        },
        {
          text: this.$t("attributes"),
          value: "attrs",
        },
      ];
    },
  },
  async mounted() {
    await this.getProducts();

    const { data } = await this.$store.dispatch("getProductGroups", {
      limit: 50,
    });
    this.productGroups = data;
  },
  created() {
    const products = localStorage.getItem("products_in_basket");
    if (products) {
      this.productsInBasket = JSON.parse(products);
    }
  },
};
</script>
